
const generateAddressMap = (name = '', options = {}) => {
  let map = {
    city: `customer${name}AddressCity`,
    number: `customer${name}AddressNumber`,
    street: `customer${name}AddressStreet`,
    zip_code: `customer${name}AddressZipCode`,
    complement: `customer${name}AddressComplement`,
    state_id: `customer${name}AddressStateID`,
    neighborhood: `customer${name}AddressNeighborhood`,
  };

  if (options.residence) {
    map = {
      ...map,
      INTERNAL_residence_separator: `customer${name}AddressResidenceSeparator`,
      set_time_year: `customer${name}AddressSetTime`,
      build_type_id: `customer${name}AddressBuildTypeID`,
      rent_value_cents: `customer${name}AddressRentValue`,
    };
  }

  if (options.conditional) {
    map = {
      ...map,
      INTERNAL_present: `customer${name}AddressPresent`,
      INTERNAL_address_separator: `customer${name}AddressSeparator`,
    };
  }

  return map;
};

export const monthlyInvoicingMap = {
  billing_cents: 'customerMonthlyInvoicingBillingCents',
  month: 'customerMonthlyInvoicingMonth',
  year: 'customerMonthlyInvoicingYear',
};

const generateMonthlyBillings = () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  .map(i => `${monthlyInvoicingMap.billing_cents}-${i}`);

export const spouseMap = {
  spouse_name: 'spouseName',
  spouse_born_at: 'spouseBirthdate',
  spouse_cpf: 'spouseCPF',
  spouse_income_cents: 'spouseIncomeCents',
};

export const personalReferenceMap = {
  name: 'customerReferenceName',
  relationship: 'customerReferenceRelationship',
  city: 'customerReferenceCity',
  phone: 'customerReferencePhone',
};

export const partnersMap = {
  name: 'customerPartnersName',
  cpf_cnpj: 'customerPartnersCpfCnpj',
  cpf: 'customerPartnersCpfCnpj',
  cnpj: 'customerPartnersCpfCnpj',
  born_at: 'customerPartnersBirthdate',

  marital_status_id: 'customerPartnersMaritalStatus',
  spouse_name: 'customerPartnersSpouseName',
  spouse_born_at: 'customerPartnersSpouseBirthdate',
  spouse_cpf: 'customerPartnersSpouseCPF',

  started_at: 'customerPartnersStartedAt',
  role: 'customerPartnersRole',

  quota: 'customerPartnersQuota',
  income_cents: 'customerPartnersIncomeCents',
};

export const bankReferenceMap = {
  INTERNAL_bank_separator: 'customerBankSeparator',
  bank_id: 'bankReferencesBankID',
  overdraft: 'bankReferenceHasOverdraft',
  agency: 'bankReferenceAgency',
  account_number: 'bankReferenceAccountNumber',
  open_at: 'bankReferenceOpenAt',
};

export const jobReferenceAddressMap = generateAddressMap('Job');

export const jobReferenceMap = {
  INTERNAL_still_works: 'customerJobStillWorks',
  joined_at: 'customerJobJoinedAt',
  income_cents: 'customerJobIncome',
  another_income_cents: 'customerJobOtherIncome',
  another_income_type_id: 'customerJobAnotherIncomeTypeID',
  detail: 'customerJobINSSNumber',
  first_job: 'customerJobFirstJob',
  professional_ocupation_id: 'customerJobOcupation',
  profession_id: 'customerJobProfession',
  department: 'customerJobDepartment',
  name: 'customerJobName',
  cnpj: 'customerJobCNPJ',
  company_activity_id: 'customerJobCompanyActivity',
  address: {
    ...jobReferenceAddressMap,
  },
  phone: 'customerJobPhone',

  INTERNAL_reply_customer_address: 'customerJobAddressReply',
  INTERNAL_reply_customer_address_separator: 'customerJobAddressReplySeparator',
};

export const previousJobReferenceMap = {
  previous_work: 'customerPreviousWork',
  previous_work_start_at: 'customerPreviousWorkStartAt',
  previous_work_end_at: 'customerPreviousWorkEndAt',
  previous_job_phone: 'customerJobPreviousWorkPhone',
};

export const accountantMap = {
  name: 'customerAccountantName',
  city: 'customerAccountantCity',
  phone: 'customerAccountantPhone',
};

export const cnhMap = {
  has_cnh: 'customerHasCNH',
  cnh: 'customerCNHNumber',
  cnh_type_id: 'customerCNHType',
};

export const nationalityMap = {
  place_of_birth: 'customerBirthCity',
  state_of_birth_id: 'customerBirthState',
};

export const emailMap = {
  address: 'customerEmail',
};

export const cellPhoneMap = {
  code: 'customerPhonesCellphone',
  number: 'customerPhonesCellphone',
  phone_confirmation_id: 'customerPhonesCellphoneValidation',
};

export const mainPhoneMap = {
  code: 'customerPhonesMain',
  number: 'customerPhonesMain',
  phone_confirmation_id: 'customerPhonesMainValidation',
};

export const mainAddressMap = generateAddressMap('Main', {
  residence: true,
});

export const previousAddressMap = generateAddressMap('Previous', {
  conditional: true,
  residence: true,
});

export const alternativeAddressMap = generateAddressMap('Alternative', {
  conditional: true,
});

export const resumePjMap = {
  cnpj: 'customerCpfCnpj',
  company_activity_id: 'customerCompanyCompanyActivityId',
  joint_stock_cents: 'customerCompanyJointStockCents',
  ie: 'customerCompanyIe',
  im: 'customerCompanyIm',
};

export const companyMap = {
  ...resumePjMap,
  monthly_billings: generateMonthlyBillings(),

  cnpj_file: 'customerCompanyCnpjFile',
  fat_file: 'customerCompanyFatFile',
  cs_file: 'customerCompanyCsFile',

  INTERNAL_joint_separator: 'customerCompanyJointSeparator',
  INTERNAL_company_files_separator: 'customerCompanyFilesSeparator',
  INTERNAL_company_fat_file_separator: 'customerCompanyFatFileSeparator',
};

export const resumeMap = {
  name: 'customerName',
  social_name: 'customerSocialName',
  nickname: 'customerNickame',
  cpf_cnpj: 'customerCpfCnpj',
  cpf: 'customerCpfCnpj',
  born_at: 'customerBirthdate',
};

export const customerTypeMap = {
  INTERNAL_customer_type: 'customerType',
  INTERNAL_customer_type_separator: 'customerTypeSeparator',
};

const customerMap = {
  ...customerTypeMap,
  ...resumeMap,
  ...companyMap,

  cnh_ocr_file: 'customerCNHOCRFile',

  genre_id: 'customerGenre',
  education_id: 'customerEducation',

  INTERNAL_property_separator: 'customerPropertySeparator',
  property: 'customerProperty',
  public_person: 'customerPublicPerson',
  INTERNAL_public_person_separator: 'customerPublicPersonSeparator',

  emails: [{
    ...emailMap,
  }],

  address: {
    ...mainAddressMap,

    INTERNAL_address_file_separator: 'customerAddressFileSeparator',
    address_file: 'customerAddressFile',
  },

  addresses: [{
    ...previousAddressMap,
  }, {
    ...alternativeAddressMap,
  }],

  nationality: 'customerNationality',
  ...nationalityMap,

  mother: 'customerMother',
  father: 'customerFather',

  document_type: 'customerDocumentType',
  INTERNAL_document_separator: 'customerRGSeparator',
  rg: 'customerRGNumber',
  rg_date: 'customerRGIssuedAt',
  rg_state_id: 'customerRGState',
  rg_issuing: 'customerRGIssuingAgency',
  INTERNAL_document_file_separator: 'customerRGUploadSeparator',
  ctps_file: 'customerCTPSFile',
  rg_front_file: 'customerRGFrontFile',
  rg_back_file: 'customerRGBackFile',
  INTERNAL_cnh_file_separator: 'customerCNHUploadSeparator',
  cnh_file: 'customerCNHFile',

  ...cnhMap,

  marital_status_id: 'customerMaritalStatus',
  ...spouseMap,

  personal_references: [{
    ...personalReferenceMap,
  }],

  partners: [{
    ...partnersMap,
  }],

  phones: [{
    ...cellPhoneMap,
  }, {
    ...mainPhoneMap,
  }],

  job_reference: {
    ...jobReferenceMap,
    ...previousJobReferenceMap,

    INTERNAL_job_file_separator: 'customerJobFileSeparator',
    job_file: 'customerJobFile',
  },

  accountant: {
    ...accountantMap,
  },

  have_credit_card: 'customerHasCreditCard',
  credit_cards: 'customerCreditCardsBrands',

  has_made_funding: 'customerHasPreviousFunding',
  previous_funding_bank_id: 'customerPreviousFundingBankID',

  have_bank_account: 'customerHasBankAccount',
  bank_references: [{
    ...bankReferenceMap,
  }],

  accept_boleto: 'customerAcceptsBoleto',

  note: 'customerNote',
};

export const attachmentMaps = [
  customerMap.address.address_file,

  customerMap.ctps_file,
  customerMap.rg_front_file,
  customerMap.rg_back_file,
  customerMap.cnh_file,
  customerMap.job_reference.job_file,
];

export const domainsMap = {
  genre: customerMap.genre_id,
  education: customerMap.education_id,
  marital_status: [
    customerMap.marital_status_id,
    customerMap.partners[0].marital_status_id,
  ],
  professional_ocupation: customerMap.job_reference.professional_ocupation_id,
  profession: customerMap.job_reference.profession_id,
  company_activity: [
    customerMap.job_reference.company_activity_id,
    customerMap.company_activity_id,
  ],
  another_income_type: customerMap.job_reference.another_income_type_id,
  document_type: customerMap.document_type,
  cnh_type: customerMap.cnh_type_id,
  property: customerMap.property,
  relationship: customerMap.personal_references[0].relationship,
  partner_role: customerMap.partners[0].role,
};

export default customerMap;
